import script from "./dayOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./dayOverview.vue?vue&type=script&setup=true&lang=js"

import "./dayOverview.vue?vue&type=style&index=0&id=2f41baac&scoped=true&lang=scss"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f41baac"]])

export default __exports__